"use client";
import "./contact-sales.css";
export default function ContactSales() {
  function openInNewTab(url) {
    if (typeof window === "undefined") return;

    window.open(url, "_blank", "noopener,noreferrer");
  }

  return (
    <section className="r2-contact-sales">
      <div className="r2-contact-sales__content">
        <h1 className="r2-contact-sales__title">
          Not sure which plan is right for you?
        </h1>
        <p className="r2-contact-sales__lead">
          Talk with our team about your fleet size, risk tolerance, and growth
          goals - we'll help you choose the best plan.
        </p>
        <div className="r2-contact-sales__cta">
          <button
            onClick={() => {
              openInNewTab(
                "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0uM38_BSjLVbenehGmJwjkETtPS1iBcJj-u7GHCenflXGoUmCy2Ec7N_k1lBX4irwNx97G7MXp"
              );
            }}
            className="r2-contact-sales__button"
          >
            Talk with RentID
          </button>
        </div>
      </div>
    </section>
  );
}
